import styled from 'styled-components';
import { Box } from '../Box';

export const ResizableGridBox = styled(Box)
    .withConfig({ displayName: 'ResizableGrid' })
    .attrs({ width: '100%' })``;
